import React from "react";
import styled from "styled-components";

import device from "../common/breakpoints";

import { ReactComponent as GatsbyLogo } from "../assets/icons/technologies/gatsby-logo.svg";
import { ReactComponent as GraphQLLogo } from "../assets/icons/technologies/graphql-logo.svg";
import { ReactComponent as NodeJSLogo } from "../assets/icons/technologies/nodejs-logo.svg";
import { ReactComponent as ReactLogo } from "../assets/icons/technologies/react-logo.svg";
import AmplifyLogo from "../assets/icons/technologies/amplify-logo.png";
import GCPLogo from "../assets/icons/technologies/gcp-logo";
import FlowLogo from "../assets/icons/technologies/flow-logo.png";

const Styled = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  padding: 1rem 5vw;

  @media ${device.tablet} {
    padding: 0 2vw 1rem;
  }

  li {
    display: inline-block;
    margin: 0.4rem 3vw;

    @media ${device.tablet} {
      margin: 0.5rem 1rem;
    }

    > a > img {
      width: 10vmax;
      height: 10vmax;

      @media ${device.tablet} {
        width: 6vmax;
        height: 6vmax;
      }

      @media ${device.tablet} and (min-resolution: 1.1dppx) {
        width: 5vmax;
        height: 5vmax;
      }
    }

    > a > svg {
      width: 10vmax;
      height: 10vmax;

      @media ${device.tablet} {
        width: 6vmax;
        height: 6vmax;
      }

      @media ${device.tablet} and (min-resolution: 1.1dppx) {
        width: 5vmax;
        height: 5vmax;
      }
    }
  }

  .gatsby > a > svg {
    width: 8vmax;
    height: 8vmax;

    @media ${device.tablet} {
      width: 5vmax;
      height: 5vmax;
    }

    @media ${device.tablet} and (min-resolution: 1.1dppx) {
      width: 4vmax;
      height: 4vmax;
    }
  }

  .nodejs > a > svg {
    width: 12vmax;
    max-height: 10vmax;

    @media ${device.tablet} {
      width: 8vmax;
    }

    @media ${device.tablet} and (min-resolution: 1.1dppx) {
      width: 6vmax;
    }
  }
`;

const Donations = () => (
  <Styled>
    <li className="react">
      <a
        href="https://reactjs.org/"
        rel="external nofollow noopener"
        target="blank"
      >
        <ReactLogo title="React - JavaScript library for building user interfaces" />
      </a>
    </li>
    <li className="graphql">
      <a
        href="https://graphql.org/"
        rel="external nofollow noopener"
        target="blank"
      >
        <GraphQLLogo title="GraphQL - Query language for APIs" />
      </a>
    </li>
    <li className="gatsby">
      <a
        href="https://www.gatsbyjs.org/"
        rel="external nofollow noopener"
        target="blank"
      >
        <GatsbyLogo title="Gatsby - React framework" />
      </a>
    </li>
    <li className="amplify">
      <a
        href="https://aws.amazon.com/amplify/"
        rel="external nofollow noopener"
        target="blank"
      >
        <img src={AmplifyLogo} alt="AWS Amplify - Development platform" />
      </a>
    </li>
    <li className="flow">
      <a
        href="https://flow.org/"
        rel="external nofollow noopener"
        target="blank"
      >
        <img src={FlowLogo} alt="Flow - Static type checker for JavaScript" />
      </a>
    </li>
    <li className="gcp">
      <a
        href="https://cloud.google.com/"
        rel="external nofollow noopener"
        target="blank"
      >
        <GCPLogo title="Google Cloud Platform - Cloud Computing Platform" />
      </a>
    </li>
    <li className="nodejs">
      <a
        href="https://nodejs.org/en/"
        rel="external nofollow noopener"
        target="blank"
      >
        <NodeJSLogo title="NodeJS - JavaScript runtime environment" />
      </a>
    </li>
  </Styled>
);

export default Donations;
